import {ApexOptions} from 'apexcharts';

export const DEFAULT_REPORTS_CHART_CONFIG: Partial<ApexOptions> = {
  chart: {
    type: 'bar',
    selection: {enabled: false},
    toolbar: {show: false},
    zoom: {enabled: false},
  },
  grid: {
    borderColor: '#555',
    yaxis: {
      lines: {show: false},
    },
  },
  dataLabels: {enabled: false},
  tooltip: {theme: 'dark'},
  yaxis: {
    labels: {style: {colors: '#6E6E78'}},
    min: 50,
    axisTicks: {show: false},
  },
  xaxis: {
    tooltip: {enabled: false},
    tickAmount: 1,
    tickPlacement: 'on',
    axisTicks: {show: false},
  },
};
